module.exports = __webpack_public_path__ + "static/media/userWaitlist.2f4498f7.svg";